export const GET_SEARCH_RESULT = 'GET_SEARCH_RESULT';
export const CLEAR_SEARCH_RESULT = 'CLEAR_SEARCH_RESULT';